import { render, staticRenderFns } from "./safe.vue?vue&type=template&id=b3143a18&scoped=true&"
import script from "./safe.js?vue&type=script&lang=js&"
export * from "./safe.js?vue&type=script&lang=js&"
import style0 from "./safe.vue?vue&type=style&index=0&id=b3143a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3143a18",
  null
  
)

export default component.exports